import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";
import useStyles from "../common/Styles";
import { useSelector } from "react-redux";
import { toolbarHeight } from "components/app/Styles";
import { filterContainerHeight, chartTitleHeight } from "../common/Styles";
import { getWindowSize } from "../common/utils";
import userActions from "../common/actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";


const AgricultureDeliveries = () => {
    const { deliveries, delivery_districts, agriculture_selected } = useSelector((state) => state.water_user);
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const classes = useStyles();
    const { setWaterUserOption } = userActions();
    const { isMobile } = useGetViewPortDimensions();

    const setWaterFunction = () => {
        setWaterUserOption(delivery_districts);
    }
    useEffect(setWaterFunction, [deliveries]);

    const options = {
        chart: {
            type: "pie",
            plotBackgroundColor: "transparent",
            backgroundColor: "transparent",
            height:
            windowSize.innerHeight -
            toolbarHeight -
            filterContainerHeight -
            chartTitleHeight -
            75,
            ...(isMobile && { width: 380 })
        },
        title: {
            text: undefined,
        },
        series: [
            {
                name: "Irrigation District Water Deliveries",
                data: [
                    {
                        name: "Golf Courses",
                        y: Math.round(deliveries[agriculture_selected.name].golf_courses),
                        color: "#6AA4DC",
                    },
                    {
                        name: "Schools & Parks",
                        y: Math.round(deliveries[agriculture_selected.name].schools_parks),
                        color: "#FFB607",
                    },
                    {
                        name: "HOA & Homeowner Yards",
                        y: Math.round(deliveries[agriculture_selected.name].hoa_homeowner_yards),
                        color: "#DE3E40",
                    },
                    {
                        name: "Industry & Other Turf",
                        y: Math.round(deliveries[agriculture_selected.name].industry_and_turfs),
                        color: "#96D9E4",
                    },
                    {
                        name: "Agriculture",
                        y: Math.round(deliveries[agriculture_selected.name].agriculture),
                        color: "#D88C31",
                    },
                    {
                        name: "Municipal Drinking Water",
                        y: Math.round(deliveries[agriculture_selected.name].municipal_drinking),
                        color: "#2352D0",
                    },
                ],
            },
        ],
        credits: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: false,
                },
                states: {
                    hover: {
                    enabled: false,
                    },
                    inactive: {
                    opacity: 1,
                    },
                },
                borderWidth: 0,
                showInLegend: true,
            },
            series: {
                point: {
                    events: {
                        legendItemClick: function () {
                            return false; // <== returning false will cancel the default action
                        },
                    },
                },
            },
        },
        tooltip: {
            padding: 16,
            backgroundColor: "#FFF",
            borderRadius: 8,
            useHTML: true,
            style: { color: "#000", fontFamily: "'Arial', sans-serif" },
            formatter() {
            return false;
            },
        },
        legend: {
            itemStyle: {
            color: "#333333",
            fontSize: "12px",
            fontWeight: "normal",
            fontFamily: "Arial",
            },
            align: "center",
            backgroundColor: "#FFFFFF",
            borderColor: "#E0E0E0",
            borderWidth: 1,
            borderRadius: 15,
            //   width: "25%",
            padding: 10,
            itemMarginTop: 5,
            itemMarginBottom: 5,
            shadow: {
            offsetX: -1,
            offsetY: 3,
            color: "#00000029",
            width: 4,
            },
            reversed: true,
        },
    };

    //gets windowSize to set width of barchart
    const handleResize = () => {
        const handleWindowResize = () => {
            setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);
        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }
    useEffect(handleResize, []);
    return (
        <Box className={classes.chartContainer}>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
    );
};

export default AgricultureDeliveries;